module.exports = __webpack_public_path__ + "1c5947aa730d3801760e98e1a40293cc.png";